import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 560px;
  margin: 0 auto;
  padding: calc(env(safe-area-inset-top) + 10px) 16px 0;
`;

export const Logo = styled.img`
  display: block;
  height: 44px;
  width: auto;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;

  a {
    color: var(--accent);
    font-weight: 600;
  }
`;
